import { formatInTimeZone } from "date-fns-tz";
import { enUS, ja } from "date-fns/locale";
import { Locale } from "~constants/i18n";

export const LOCALE_TIMEZONE_MAP: Record<Locale, string> = {
  en: "America/New_York",
  ja: "Asia/Tokyo",
};

const LOCALE_MAP = {
  en: enUS,
  ja,
};

export type DateLike = string | number | Date;

export default function timeFormat(
  date: DateLike,
  locale: Locale,
  format: string
) {
  if (!date || isNaN(new Date(date).getTime())) {
    return "";
  }

  return formatInTimeZone(date, LOCALE_TIMEZONE_MAP[locale], format, {
    locale: LOCALE_MAP[locale],
  });
}

export function nyTimeFormat(
  date: DateLike,
  format: string,
  locale: Locale = Locale.En
) {
  return timeFormat(date, locale, format);
}

export function getTimezoneAbbreviation(
  date: Date,
  locale: Locale
): string | null {
  const timeZone = LOCALE_TIMEZONE_MAP[locale];

  if (locale === Locale.Ja) {
    return "JST";
  }

  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    timeZoneName: "shortOffset",
    hour: "2-digit",
  }).formatToParts(date);

  const offset = parts.find((p) => p.type === "timeZoneName")?.value;

  return offset === "GMT-4" ? "EDT" : "EST";
}
